const t={path:"/oauth/authorization_code",method:"POST"},o={path:"/oauth/verify",method:"POST"};export{t as OAuthProviderAuthorize,o as OAuthProviderVerify};
